import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './CategoryNav.css';

export default function CategoryNav({ categories, currentIndex, onJump }) {
  const activeIdx = categories.reduce((best, cat, i) =>
    cat.startIndex <= currentIndex ? i : best, 0);

  const go = (i) => onJump(categories[(i + categories.length) % categories.length].startIndex);

  return (
    <div className="category-nav">
      <button className="cat-arrow retro-btn" onClick={() => go(activeIdx - 1)} aria-label="Previous category">
        <FaChevronLeft />
      </button>
      <select
        className="cat-select retro-btn"
        value={activeIdx}
        onChange={e => onJump(categories[Number(e.target.value)].startIndex)}
      >
        {categories.map((cat, i) => (
          <option key={cat.id} value={i}>{cat.name}</option>
        ))}
      </select>
      <button className="cat-arrow retro-btn" onClick={() => go(activeIdx + 1)} aria-label="Next category">
        <FaChevronRight />
      </button>
    </div>
  );
}
